<script setup>
  import { onUnmounted } from "vue";
  import TwoPanePage from "@templates/TwoPanePage.vue";
  import ActionList from "@/components/MCampaign/Actions/ActionList.vue";
  import ActionEdit from "@/components/MCampaign/Actions/ActionEdit.vue";
  import { useMCampaignActionsStore } from "@stores/mCampaignActions";
  import { useUnsavedChangesGuard } from "@/utils/composables/useUnsavedChangesGuard";
  import { useMCampaignUnsavedChanges } from "@/utils/composables/useMCampaignUnsavedChanges";

  const { clearActionsSubmission } = useMCampaignActionsStore();

  onUnmounted(clearActionsSubmission);

  useUnsavedChangesGuard(useMCampaignUnsavedChanges().hasUnsavedChanges);
</script>

<template>
  <TwoPanePage data-cy="master-campaign-actions-page">
    <template #left>
      <ActionList />
    </template>
    <template #right>
      <ActionEdit />
    </template>
  </TwoPanePage>
</template>
